import { apiClient } from './api-client';
import type { ScoringPreviewData } from '../types/scoring-preview';

export async function fetchScoringPreview(quizId: string): Promise<ScoringPreviewData> {
  return apiClient<ScoringPreviewData>(`/admin/scoring-preview/${quizId}`);
}
